import React, {Component, ReactNode} from 'react';
import {inject, observer} from 'mobx-react';
import SmartFullPageLoader from 'app/components/reusable/smart_loaders/SmartFullPageLoader';
import {ShopTableInterface} from 'app/interfaces/ShopTableInterface';
import ShopTableLootboxes from './ShopTableLootboxes';
import I18n from 'app/i18n';

@inject('shopStore')
@observer
export default class LootboxesContainer extends Component<ShopTableInterface> {
    render(): ReactNode {
        const {loading, data} = this.props.shopStore;
        const title = `${I18n.t('menu_links.shop')} - ${I18n.t('lootboxes')}`;
        return <>
            <h1 className="visually-hidden-title">{title}</h1>
            {loading || !data.lootboxes
                ? <SmartFullPageLoader />
                : <ShopTableLootboxes {...this.props} />}
        </>;
    }
}

